var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "backup-codes" }, [
    _c("div", { staticClass: "backup-codes__header" }, [
      _c("div", { staticClass: "row items-center" }, [
        _c("div", { staticClass: "col" }, [
          _c("h6", { staticClass: "inline-block q-ma-none" }, [
            _vm._v(_vm._s(_vm.$t("backup_codes")))
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-auto" },
          [_c("copy-button", { attrs: { text: _vm.backupCodesText } })],
          1
        )
      ])
    ]),
    _c(
      "div",
      { staticClass: "backup-codes__body" },
      _vm._l(_vm.backupCodes, function(backupCode, index) {
        return _c("span", { key: index }, [_vm._v(_vm._s(backupCode))])
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }